import { START_LOADING,END_LOADING, FETCH, CREATE, USER,UPDATE, DELETE , ACTION, FETCH_ALL,  SET_ERROR, CLEAR_ERROR, GET_ERROR, FETCH_BY_ID, RESET, UPDATE_MULTIPART, FETCH_FULL_INFO_BY_ID, UPDATE_USER, FETCH_WITH_QUERY} from '../constants/actionTypes';

const initialState = {
    user:[],
    users:[],
    userInfo:null,
    isLoading: false,
    error: null
};

const userReducer = (state = initialState,action) =>{
    if(action?.payload?.type === USER ){
        switch (action.type){
            case GET_ERROR:
                return {...state,error: null};
            case CLEAR_ERROR:
                return { ...state, error: null};
            case SET_ERROR:
                return { ...state,  error: action.payload.error};
            case START_LOADING:
                return {...state, isLoading:true}
            case END_LOADING:
                return {...state, isLoading:false};
            case FETCH_WITH_QUERY:
                return {...state, users: action.payload};
            case FETCH_FULL_INFO_BY_ID: 
                return {...state, userInfo: action.payload.data};
            case UPDATE_USER:
                return {...state, userInfo: state.userInfo._id === action.payload.data._id ? { ...state.userInfo, ...action.payload.data } : state.userInfo };
            case FETCH: 
                return {...state, user: action.payload.data};
            case FETCH_ALL: 
                return {...state, users: action.payload.data};
            case FETCH_BY_ID: 
            return {...state, user: action.payload.data};      
            case CREATE:
                return { ...state, user: [...state.user, action.payload] };
            case UPDATE:
                return {...state, user: state.user._id === action.payload.data._id ? { ...state.user, ...action.payload.data } : state.user };
            case UPDATE_MULTIPART:
                return {...state, user: state.user._id === action.payload.data._id ? { ...state.user, ...action.payload.data } : state.user };
            case DELETE:
                return {...state, user: state.user.map((user) => user._id !== action.payload) };
            case ACTION:
                return {...state, user:  action.payload.data};
            case RESET:
                return initialState;
            default:
                return state;
            }
    }
    else{
        return state;
    }
};
export default userReducer;